module.exports = "mutation DeleteTag($tagId:ID!){deleteProductTag(tagId:$tagId){success}}"